var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._v(
      " Estas viendo los registros del " +
        _vm._s(_vm.inicio) +
        " al " +
        _vm._s(_vm.fin) +
        " de un total de " +
        _vm._s(_vm.registrosTotales) +
        ". "
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }